export const AI_IMAGE_EXAMPLES = [
    {
        id: 'fashion-editorial',
        title: '',
        modelId: 'nano-banana-2',
        prompt: "A nostalgic polaroid-style photo of a young European couple standing close together, relaxed and affectionate, soft natural smiles, captured like a candid vacation moment. Soft warm beige and cream-toned background with subtle gradient, minimal and clean environment, consistent with luxury beauty campaign aesthetics. Vintage film look with gentle grain, slight color fading, soft highlights, and imperfect framing. White polaroid border around the image, slightly tilted composition, small timestamp in the bottom corner. Emotional yet refined, not cluttered. Cinematic soft lighting, ultra realistic, soft contrast, coherent color grading, 4k, high detail, shallow depth of field",
        imageUrl:
            'https://cdn.lipsync.video/lipsync/web/webp/gpt-image-2/chatGPT-Image-2-Sample-02.webp',
        referenceImages: [
        ],
        settings: {
            aspectRatio: '3:2',
            resolution: '1K'
        }
    },
    {
        id: 'product-studios',
        title: '',
        modelId: 'gpt-image-2',
        prompt: 'Create a cute cartoon girl with a cheerful smile, large expressive eyes, and soft, rounded facial features. She has shoulder-length hair, a colorful casual outfit, and a friendly, energetic personality. The illustration should feature clean vector-style lines, vibrant colors, and a modern flat-cartoon aesthetic. The character is standing in a playful pose, waving with one hand, against a simple pastel background with subtle decorative elements. High quality, crisp details, suitable for social media, marketing materials, and thumbnails.',
        imageUrl:
            'https://tempfile.mediaoss.bar/images/chatgpt/file_00000000fba881f589565fd7c490daa2.png',
        referenceImages: [],
        settings: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    {
        id: 'character-pose',
        title: '',
        modelId: 'wan-2.7-image-pro',
        prompt: 'These three people are gathered by the seaside, chatting and laughing together, with the person in the middle holding the banana from Figure 1.',
        imageUrl:
            'https://static.crunai.com/g/a4e91561-67e8-40d6-9c0a-f14a6ab26a2f_0.png',
        referenceImages: [
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/639ff026c388477fb5e9498582661dd2.png',
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/d894dc554de540a3ad1825da1e7be370.png',
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/f7e5723fb240465cabb2aa4a65900ea1.png',
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/70f23538bc074449814f0f665eb7adfb.png'
        ],
        settings: {
            aspectRatio: '3:4',
            resolution: '1K',
            samples: 1
        }
    },
    {
        id: 'animal-expression',
        title: '',
        modelId: 'wan-2.7-image',
        prompt: 'Put him in a professional setting with a professional attire.',
        imageUrl:
            'https://static.crunai.com/g/46f8abb7-ea44-4002-930d-678db051d5a9_0.png',
        referenceImages: [
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/35d115be05424f2c9bef9197a8cdf0f9.png'
        ],
        settings: {
            aspectRatio: '1:1',
            resolution: '1K',
            samples: 1
        }
    },
    {
        id: 'storybook-princess',
        title: '',
        modelId: 'nano-banana-2-lite',
        prompt: 'Create a charming storybook character portrait with soft cinematic lighting, expressive eyes, elegant costume details, warm colors, and a dreamy castle background.',
        imageUrl:
            'https://tempfile.mediaoss.bar/ggc/ad1e41644167e11492674e92a3fa7419_1785399218119.jpeg',
        referenceImages: [
            'https://result.lip-sync.ai/upload/login_user/default/202607/30/8a102c27e84e40f2b9d0797f2b607b68.jpeg'
        ],
        settings: {
            aspectRatio: '3:4'
        }
    },
    {
        id: 'toy-package',
        title: '',
        modelId: 'grok-imagine',
        prompt: 'A high-angle, long-shot photograph taken from a grassy bluff overlooking a sandy California beach, shrouded in a heavy, pervasive sea fog or marine layer. The scene is rendered in muted, near-monochrome tones with low saturation. The vast expanse of the gray ocean is calm with small white-capped waves. Scattered people are small silhouettes along the shore and in the water. To the far left, a line of distant houses with some palm trees are partially obscured by the mist. The sky is an opaque, desaturated gray. The foreground left is dominated by dark, wild succulents and grasses, slightly out of focus. A sense of cold, desolate stillness. (Analog film photography style, 35mm, shot on Kodak Portra, light grain)',
        imageUrl:
            'https://static.crunai.com/g/82ea2b30-bd97-48a8-9782-0f35d4080623_0.png',
        referenceImages: [],
        settings: {
            aspectRatio: '3:2'
        }
    }
];
